export default __webpack_public_path__ + "static/media/terraform.a6542f05.svg";